import React from "react";
import { connect } from "react-redux";
import { useSelfUser } from "../reducers/accounts/user";
import {
  deselectOrganization,
  selectOrganization,
} from "../actions/accounts/user";

const OrganizationScroller = ({ selectOrganization, deselectOrganization }) => {
  const { user } = useSelfUser();
  const handleClick = (item) => {
    if (item?.selected) deselectOrganization(item);
    else selectOrganization(item);
  };
  const items = user?.organizations?.map((item, index) => {
    return (
      <li
        onClick={() => handleClick(item)}
        style={{
          cursor: "pointer",
          display: "inline-block",
          padding: "7px 15px",
          border: "1px solid #272660",
          borderRadius: "10px",
          marginLeft: index > 0 ? "10px" : 0,
          color: item?.selected ? "white" : "#272660",
          backgroundColor: item?.selected ? "#272660" : "white",
        }}
      >
        {item.name}
      </li>
    );
  });
  return (
    <>
      <ul>{items}</ul>
    </>
  );
};

export default connect(null, { selectOrganization, deselectOrganization })(
  OrganizationScroller
);
